export var EventType;
(function (EventType) {
    EventType["StartUp"] = "StartUp";
})(EventType || (EventType = {}));
export default EventType;
//# sourceMappingURL=EventType.js.map